import { ReactElement } from 'react'
import {
  BackButton,
  PageWrapper,
  FlexWrapper,
  Column
} from '../../../../components'
import { useHistory } from 'react-router-dom'
import { CardWrapper } from '../subcomponents'
import { useSelector, shallowEqual, useDispatch } from 'react-redux'
import { RootState } from '../../../../redux/store'
import strings from '../../../../locale/en'
import { resetSelectedCourse } from '../../../../redux/course/action'

const View = (): ReactElement => {
  const { selectedCourse } = useSelector(
    (state: RootState) => state.course,
    shallowEqual
  )
  const history = useHistory()
  const dispatch = useDispatch()
  const {
    menu: {
      course: {
        view: { courseName, parentCourse, description, status }
      }
    }
  } = strings

  return (
    <PageWrapper id="container">
      <div>
        <BackButton
          handleBack={() => {
            dispatch(resetSelectedCourse())
            history.goBack()
          }}
        />
      </div>
      <FlexWrapper justifyContent="space-around">
        <CardWrapper>
          <Column keyName={courseName} value={selectedCourse?.courseName} />
          <Column keyName={parentCourse} value={selectedCourse?.parentName} />
        </CardWrapper>
        <CardWrapper>
          <Column keyName={description} value={selectedCourse?.description} />
          <Column keyName={status} value={selectedCourse?.status} />
        </CardWrapper>
      </FlexWrapper>
    </PageWrapper>
  )
}

export default View
